import { Injectable } from '@angular/core';
import { ConversationResponse } from '../../common/models/conversation-response.models';
import { CommunicationType } from '../../common/models/communication-type.enum';
import { ConversationConverterService } from '../../common/services/conversation-converter-base.service';
import { Participant } from '../../common/models/participant.model';
import { ConnectionState } from '../../common/models/connection-state.enum';
import { MessageConversation } from '../models/message-conversation.model';
import { ParticipantPurpose } from 'common/store/genesys-cloud/conversations/common/models/participant-purpose.enum';

@Injectable({
  providedIn: 'root'
})
export class MessageConversationConverterService extends ConversationConverterService {
  convert(conversationResponse: ConversationResponse, agentUserId: string): MessageConversation {
    const agentParticipant = this.getAgentParticipant(conversationResponse, agentUserId);

    return {
      ...conversationResponse,
      isActive: this.hasUnfilledWrapup(agentParticipant) || this.hasActiveParticipantMessage(agentParticipant),
      isAcceptable: this.hasAlertingParticipantMessage(agentParticipant),
      customerParticipant: this.getCustomerParticipant(conversationResponse),
      agentParticipant,
      communicationType: CommunicationType.Message,
      workflowParticipants: this.getWorkflowParticipants(conversationResponse),
      acdParticipants: this.getAcdParticipants(conversationResponse)
    };
  }

  private hasActiveParticipantMessage(participant: Participant): boolean {
    return participant.messages?.some(pm => ConversationConverterService.activeParticipantMessageTypes.has(pm.state.toLowerCase()));
  }

  private hasAlertingParticipantMessage(participant: Participant): boolean {
    return participant.messages?.some(pm => pm.state.toLowerCase() === ConnectionState.Alerting);
  }

  private getWorkflowParticipants(conversation: ConversationResponse): Participant[] {
    return conversation.participants.filter(p => p.purpose === ParticipantPurpose.Workflow);
  }
}
